var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('el-progress',{attrs:{"stroke-width":38,"percentage":_vm._percentage,"stroke-linecap":"butt","color":"#ff9300","show-text":false}}),_c('div',{staticClass:"progress-text",class:{'t-w': _vm.step > parseInt(this.total / 1.75)}},[_vm._v("答题进度"+_vm._s(_vm._percentage)+"%")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }